import React, { Component } from 'react'
import { connect } from 'react-redux'
import UserActions from '../../actions/user/user-actions'
import './login-cp.css'
// import CheckBoxCP from '../checkBox/CheckBoxCP'

class PWResetCP extends Component {
  constructor () {
    super()
    this.state = {
      email: '',
      passwordA: '',
      passwordB: '',
      pwMessage: '',
    }

    this.onInputChange = this.onInputChange.bind(this)
    this.onReset = this.onReset.bind(this)
  }

  // componentDidMount() {}

  render () {
    return (
      <div className='login-contain'>
        <div className='login-content'>
          <div className='spacerEle'>
            {this.props.loginResponse} &nbsp;
          </div>

          <form onSubmit={this.onReset}>
            <div className='spacerEle'>
              email: <input type='text' name='emailInput' className='bcioInput' 
              value={this.state.email} onChange={(event => this.onInputChange('email', event))} 
              disabled={this.props.isLoggingIn} />
            </div>
            <div className='spacerEle'>
              password: <input type='password' name='passwordAInput' className='bcioInput'
              value={this.state.passwordA} onChange={(event => this.onInputChange('passwordA', event))} 
              disabled={this.props.isLoggingIn} />
            </div>
            <div className='spacerEle'>
              password: <input type='password' name='passwordBInput' className='bcioInput'
              value={this.state.passwordB} onChange={(event => this.onInputChange('passwordB', event))} 
              disabled={this.props.isLoggingIn} />
            </div>
            <div className='spacerSection'></div>
            <div className='spacerEle'>
              <button className='bcioButton' role='' onClick={this.onReset} disabled={this.props.isLoggingIn} >Reset</button>
            </div>
          </form>

          <div className='spacerEle' style={{color: '#cc4444'}}>
            {this.state.pwMessage} &nbsp;
          </div>
          <div className='spacerEle'>
            <a href="/">Login</a>
          </div>
          { /*
          // for future
          
          <div className='spacerEle'>
            <div className='bcioInputCircle'>
              <div className='bcioCheckmark'></div>
            </div> Make This A Component
          </div>
          <CheckBoxCP className='spacerEle' onClick={(checked, event) => {console.log(checked)}} /> Label
          */ }
        </div>
      </div>
    )
  }

  onInputChange (prop, event) {
    var newState = {}
    newState[prop] = event.target.value
    this.setState(newState)
  }

  onReset (event) {
    let token = (window.location.hash).substring(1)
    event.stopPropagation()
    if (this.state.passwordA === this.state.passwordB) {
      this.props.resetPW(this.state.email, this.state.passwordA, token)
    } else {
      this.setState({pwMessage: 'Passwords do not match'})
    }
  }
}

const mapStateToProps = (state) => {
  return {
    isLoggingIn: state.user.isLoggingIn,
    loginResponse: state.user.loginResponse,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    resetPW: (email, password, token) => dispatch(UserActions.resetPW(email, password, token)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PWResetCP)
